<template>
  <div class="inner">
    <!-- <Header></Header> -->
    <div class="content">
      <div class="title">{{ newsDetail.title }}</div>
      <div class="date">
        时间：<span>{{ newsDetail.gmtCreate }}</span>
      </div>
      <div class="desc" v-html="newsDetail.content"></div>
    </div>
    <!-- <Footer v-if="$store.state.common.bureau.siteBottomShow == '1' && !isCustom"></Footer> -->
    <!-- <HeiFooter v-if="$store.state.common.bureau.siteBottomShow == '1' && isCustom"></HeiFooter> -->
  </div>
</template>
<script>
// import Header from '../../components/Header'

// import Footer from '../../components/Footer'

// import HeiFooter from '../../components/HeiFooter'

import setting from '../../api/setting'

// import { urlCustom } from './HeiUrl'

export default {
  name: 'newsDetail',
  // components: {
  //   Header,
  //   Footer,
  //   HeiFooter,
  // },
  data() {
    return {
      newsDetail: {},
      isCustom: false,
    }
  },
  methods: {
    getNewsDetail() {
      setting
        .getNews(this.$route.query.id)
        .then((res) => {
          this.newsDetail = res.data
        })
        .catch((res) => {
          if (res) {
            this.$message.error('未找到当前通知与公告')
            setTimeout(() => {
              this.$router.push('/school/portal')
            }, 2000)
          }
        })
    },
  },
  created() {
    this.getNewsDetail()
    // urlCustom.forEach(e => {
    //   if (window.location.href.indexOf(e) != -1) {
    //     this.isCustom = true
    //     return
    //   }
    // })
  },
}
</script>
<style lang="less" scoped>
// @import 'src/config/var';
.content {
  padding: 114px 0px 50px;
  max-width: 1140px;
  margin: 0px auto;
  @media screen and (max-width: 695px) {
    padding: 45px 32px 50px;
    ::v-deep img {
      max-width: 100%;
    }
  }
  ::v-deep img {
    max-width: 100%;
  }
  > .title {
    text-align: center;
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 16px;
    color: #151517;
    @media screen and (max-width: 695px) {
      font-size: 20px;
      line-height: 28px;
    }
  }
  > .date {
    font-size: 14px;
    color: #909399;
    margin-bottom: 50px;
    text-align: center;
    @media screen and (max-width: 695px) {
      font-size: 12px;
      margin-bottom: 14px;
    }
  }
  > .desc {
    font-size: 16px;
    line-height: 24px;
  }
}

@media screen and (max-width: 695px) {
  img {
    width: 100px;
  }
}
</style>
